export const ONSTREET_PRODUCT_ID = 2;
export const ENFORCER_PRODUCT_ID = 4;
export const STREET_PRODUCT_ID = 5;
